export default __webpack_public_path__ + "static/media/tokenmetricV2.b4453bf3.png";